module.exports = __webpack_public_path__ + "img/lianbao@2x.55459d26.png";